module.exports = __webpack_public_path__ + "static/media/HomePage-item2.f392e111.webp";